import { Truck, AlertTriangle, Clock } from "lucide-react";
import { describeAvailability, AvailabilityLike, LegType } from "@/features/delivery/lib/deliveryPresentation.js";

interface DeliveryServiceBannerProps {
  availability?: AvailabilityLike | null;
  currencySymbol: string;
  type?: LegType;
}

const TONE_STYLES: Record<string, string> = {
  available: "border-green-200 bg-green-50 text-green-800",
  surcharge: "border-amber-200 bg-amber-50 text-amber-800",
  unavailable: "border-neutral-200 bg-neutral-50 text-neutral-600",
};

/**
 * Presents delivery availability for a station leg. Pure presentation: all
 * copy/tone decisions come from the tested describeAvailability helper.
 */
export default function DeliveryServiceBanner({ availability, currencySymbol, type = "pickup" }: DeliveryServiceBannerProps) {
  if (!availability) {
    return null;
  }

  const descriptor = describeAvailability(availability, currencySymbol, type);
  const Icon = descriptor.tone === "surcharge" ? Clock : descriptor.tone === "unavailable" ? AlertTriangle : Truck;

  return (
    <div className={`flex items-start gap-2 rounded-md border p-3 text-sm ${TONE_STYLES[descriptor.tone]}`} role="status">
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div>
        <p className="font-semibold">{descriptor.headline}</p>
        <p>{descriptor.note}</p>
      </div>
    </div>
  );
}
